<script>
import appConfig from '@src/app.config'
import { authMethods, authComputed } from '@state/helpers'
import mainVue from './router/layouts/main.vue'
import './assets/styles.css'
import '@mdi/js'
export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  created() {},
  computed: {
    ...authComputed,
  },
  watch: {
    isLoggedIn(val) {
      if (!val) {
        this.$router.push({ path: '/' })
      }
    },
  },
  methods: {
    ...authMethods,
    setUpTokenRefresh() {
      try {
        //this refreshes the etsjwt token
        window.setInterval(() => {
          this.refreshToken()
        }, 1000 * 60 * 20)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
  },
  mounted() {
    this.setUpTokenRefresh()
    this.refreshToken()
  },
  components: { Layout: mainVue },
}
</script>
<template>
  <div id="app">
    <v-app>
      <Layout>
        <!--
        $route.fullPath - will always load components as distinct components
        this will allow you to navigate from one instance of a component to another
        (from one item to another) and it will recreate the component so that the data is changed
        -->
        <RouterView :key="$route.fullPath" />
      </Layout>
    </v-app>
  </div>
</template>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
